export const emailPlaceholder = {
    us: 'Email',
    ca: 'Email',
    eu: 'Email',
    uk: 'Email',
    jp: 'メール',
};
